import React from 'react';
import type { Size } from '../../types';

const fantomLogo = (width: Size = '120', height: Size = '160') => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0,0,120,160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M26 42.1622L59.6 24.0001L93.2 42.1622V80.0001V117.838L59.6 136L26 117.838V80.0001V42.1622Z"
                fill="url(#paint0_linear_9446_42744)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M57.6979 23.323C58.8848 22.6815 60.3152 22.6815 61.5021 23.323L91.5531 39.5668C93.4918 40.6148 94.7 42.6412 94.7 44.8451V115.155C94.7 117.359 93.4918 119.385 91.5531 120.433L62.4531 136.163C60.6728 137.125 58.5272 137.125 56.7469 136.163L27.6469 120.433C25.7082 119.385 24.5 117.359 24.5 115.155V44.8451C24.5 42.6412 25.7082 40.6148 27.6469 39.5668L57.6979 23.323ZM27.5 44.6781V77.3834L56.5423 60.3766L27.5 44.6781ZM58.1 62.941L28.9684 80L58.1 97.059V62.941ZM61.1 97.059L90.2316 80L61.1 62.941V97.059ZM59.6 58.6192L90.0455 42.1622L59.6 25.7051L29.1545 42.1622L59.6 58.6192ZM91.7 44.6781L62.6577 60.3766L91.7 77.3834V44.6781ZM91.7 82.6166L62.6319 99.6385C60.7594 100.735 58.4406 100.735 56.5681 99.6385L27.5 82.6166V114.559C27.5 116.028 28.3054 117.379 29.5979 118.078L57.6979 133.267C58.8848 133.908 60.3152 133.908 61.5021 133.267L89.6021 118.078C90.8945 117.379 91.7 116.028 91.7 114.559V82.6166Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_9446_42744"
                    x1="42.5"
                    y1="112.5"
                    x2="120.99"
                    y2="71.3123"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" stopOpacity="0.06" />
                    <stop offset="1" stopColor="white" stopOpacity="0.85" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default fantomLogo;
